import { HelpAndSupportModal } from '../ui';
import { useModalStore } from '@/shared/lib';

type Params = {
  onBack: () => void;
  ewalletAccNum: string | undefined;
};

export function useHelpAndSupportModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openHelpAndSupportModal = ({ onBack, ewalletAccNum }: Params) => {
    showDialogComponent({
      component: (
        <HelpAndSupportModal onBack={onBack} ewalletAccNum={ewalletAccNum} />
      ),
      className:
        'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto bg-secondary-bg border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openHelpAndSupportModal };
}
